import { useQuery } from '@tanstack/react-query'
import { SITE_ADMIN_USER_DETAIL } from '@/endpoints'
import axios from '@/lib/axios'

export function useGetSiteAdminUserDetail(userId, args = {}) {
    return useQuery({
        queryKey: ['siteAdmin', 'users', 'detail', userId],
        queryFn: async () => {
            const response = await axios.get(SITE_ADMIN_USER_DETAIL(userId))
            return response.data
        },
        enabled: Boolean(userId),
        ...args
    })
}
